import React, { useEffect, useState } from 'react';
import { Loader2, SearchX, MessageSquareText } from 'lucide-react';
import { whatsappAPI } from './whatsappAPI';
import { semMarcas } from './waFormat';
import { fmtProtocolo } from './PainelCliente';
import { telefoneConversa } from './organizacao';

/* Resultado da busca global (todas as conversas, não só a aba aberta):
 * nome, telefone, CPF/CNPJ do cadastro, protocolo e palavras ditas na conversa. */

const MOTIVO = { nome: null, telefone: 'telefone', CPF: 'CPF', cliente: 'cadastro', protocolo: 'protocolo' };
const nomeConv = (c) => c.cliente_nome || c.push_name || telefoneConversa(c) || 'Contato do WhatsApp';

function Destaque({ texto, termo }) {
  if (!termo || termo.length < 2) return texto;
  const base = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const i = base(texto).indexOf(base(termo));
  if (i < 0) return texto;
  return <>{texto.slice(0, i)}<mark className="bg-amber-200/80 dark:bg-amber-500/40 text-inherit rounded px-0.5">{texto.slice(i, i + termo.length)}</mark>{texto.slice(i + termo.length)}</>;
}

export default function BuscaGlobal({ termo, onAbrirConversa, onAbrirMensagem, avatar: Avatar }) {
  const [res, setRes] = useState(null);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    const q = termo.trim();
    if (q.length < 2) { setRes(null); return undefined; }
    setCarregando(true);
    let vivo = true;
    const t = setTimeout(async () => {
      try { const { data } = await whatsappAPI.busca(q); if (vivo) setRes(data); }
      catch (_) { if (vivo) setRes({ conversas: [], mensagens: [] }); }
      finally { if (vivo) setCarregando(false); }
    }, 350);
    return () => { vivo = false; clearTimeout(t); };
  }, [termo]);

  const q = termo.trim();
  if (!res) return <div className="p-6 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  const vazio = !res.conversas.length && !res.mensagens.length;

  return (
    <div className={`pb-4 transition-opacity ${carregando ? 'opacity-60' : ''}`} data-testid="wa-busca-resultados">
      {vazio && (
        <div className="px-6 py-10 text-center text-sm text-slate-500">
          <SearchX className="w-8 h-8 mx-auto mb-2 text-slate-300" />
          Nada encontrado para “{q}”.
          <p className="text-xs mt-1">Busque por nome, telefone, CPF/CNPJ, protocolo (#2026-000123) ou uma palavra da conversa.</p>
        </div>
      )}
      {res.conversas.length > 0 && (
        <>
          <p className="px-4 pt-2 pb-1 text-xs font-semibold text-slate-500">Conversas</p>
          {res.conversas.map(c => (
            <button key={c.jid} onClick={() => onAbrirConversa(c)} data-testid={`wa-busca-conv-${c.numero}`}
              className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-800/60">
              <Avatar name={nomeConv(c)} size={36} />
              <span className="min-w-0 flex-1">
                <span className="text-sm font-medium truncate block"><Destaque texto={nomeConv(c)} termo={q} /></span>
                <span className="text-xs text-slate-500 truncate block">
                  {MOTIVO[c.motivo] ? <span className="text-emerald-700 dark:text-emerald-400 font-medium">{MOTIVO[c.motivo]}</span> : null}
                  {MOTIVO[c.motivo] ? ' ' : ''}{c.protocolo ? fmtProtocolo(c.protocolo) : telefoneConversa(c)}
                </span>
              </span>
            </button>
          ))}
        </>
      )}
      {res.mensagens.length > 0 && (
        <>
          <p className="px-4 pt-3 pb-1 text-xs font-semibold text-slate-500 flex items-center gap-1.5"><MessageSquareText className="w-3.5 h-3.5" /> Mensagens</p>
          {res.mensagens.map(m => (
            <button key={m.id} onClick={() => onAbrirMensagem(m)} data-testid={`wa-busca-msg-${m.id}`}
              className="w-full px-4 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-800/60">
              <span className="flex items-baseline gap-2">
                <span className="text-sm font-medium truncate flex-1">{m.conversa_nome}</span>
                <span className="text-[11px] text-slate-400 shrink-0">{new Date(m.timestamp).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' })}</span>
              </span>
              <span className="text-[13px] text-slate-600 dark:text-slate-300 line-clamp-2 block">
                {m.from_me && <span className="text-slate-400">{m.sent_by_name ? `${m.sent_by_name.split(' ')[0]}: ` : 'Você: '}</span>}
                <Destaque texto={semMarcas(m.trecho || '')} termo={q} />
              </span>
            </button>
          ))}
        </>
      )}
    </div>
  );
}
